import { withTranslation } from 'react-i18next';
import Home from './Home';

export default withTranslation()(Home);
